export function compatWarnings(mats) {
  const out = new Set();
  for (const a of mats) {
    for (const b of mats) {
      if (!a || !b || a.id === b.id) continue;
      for (const kw of a.incompatible_with || []) {
        const k = String(kw).toLowerCase();
        if ((b.product || "").toLowerCase().includes(k) || (b.active_ingredient || "").toLowerCase().includes(k)) {
          out.add(`${a.product} × ${b.product}: label/CDMS flags "${kw}"${a.compatibility_notes ? ` — ${a.compatibility_notes}` : ""}`);
        }
      }
    }
  }
  return [...out].sort();
}

export function rateOutOfRange(m, rate) {
  const r = Number(rate);
  return !!(m && r > 0 && m.rate_min != null && m.rate_max != null && (r < m.rate_min || r > m.rate_max));
}

export const LABEL_DB_URL = "https://www.cdms.net/Label-Database";
export const labelSearchUrl = (product) => `${LABEL_DB_URL}?q=${encodeURIComponent(product || "")}`;
